// Modules
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { PageContent } from 'components/page';
import { RoundLoader } from 'components/widgets/state-indicators/loader';
import DriveFilesList from 'components/models/files/drive-files-list';
import EmptyPagePlaceholder from 'components/page/empty-page-placeholder';
import Ticket from 'services/data/ticket';

import * as util from '../utils/load-ticket';


// Component
class TicketTasks extends React.Component {
  static propTypes = {
    ticket: PropTypes.object,
    files: PropTypes.array
  };

  constructor() {
    super();

    this.state = {};
    this.addFolder = this.addFolder.bind(this);
    this.onFileAdd = this.onFileAdd.bind(this);
  }

  onFileAdd() {
    util.loadFolder(this.props.ticket);
  }

  addFolder() {
    const { ticket, updateTicket } = this.props;

    this.setState({ fetching: true });

    Ticket.update({ id: ticket.id, folder: { filename: ticket.description } })
      .tap(updated => updateTicket({ folder: updated.folder }))
      .tap(util.loadFolder);
  }

  render() {
    const { ticket, files } = this.props;
    const { fetching } = this.state;
    
    if (!ticket || _.isEmpty(ticket)) return null;
    if (fetching && !files) return <RoundLoader color="#34495e" className="page-loader" />;
    if (!ticket.folder) return <EmptyPagePlaceholder onClick={this.addFolder} src="svg/google-drive.svg">Click here to add a folder to this ticket!</EmptyPagePlaceholder>;

    return (
      <PageContent className="ticket p-0">
        <div className="ticket-files">
          <DriveFilesList onFileAdd={this.onFileAdd} files={files} folder={ticket.folder} />
        </div>
      </PageContent>
    );
  }
}

// Exports
export default connect((state) => ({
  ticket: state.tickets.ticket,
  files: state.tickets.files
}))(TicketTasks);



// WEBPACK FOOTER //
// ./app/routes/ticket/sub-routes/ticket-files.js